import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../CSS/global.css'
import CoopLogo from '../../Images/CoopDashboard.png';
import * as CleanersDashboardTokenExpireConstant from './CleanersDashboardTokenExpireConstant'
import './CleanersDashboardTokenExpire.css'
import * as Config from '../../Config/Config'

class CleanersDashboardTokenExpire extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutUrlDevUat: false,
      logoutUrlProd: false,
    }
  }
  componentWillMount() {
    if (Config.ENVIRONMENT === 'DEV') {
      this.setState({
        logoutUrlDevUat: true
      })

    }
    else if (Config.ENVIRONMENT === 'UAT') {
      this.setState({
        logoutUrlDevUat: true
      })
    }
    else if (Config.ENVIRONMENT === 'PROD') {
      this.setState({
        logoutUrlProd: true
      })
    }
  }
  render() {
    return (
      <div>
        <div>
          <img src={CoopLogo} className="img-coop-logo-dashboard-invalid"></img>
        </div>
        <div className="DashboardLogOut">
          <p>{CleanersDashboardTokenExpireConstant.DashboardLogoutP}</p>
          <br />
          {this.state.logoutUrlProd ? <p className="linkPara">{CleanersDashboardTokenExpireConstant.DashboardLogoutP1} <a href="https://visit-cleaners-dashboard.azurewebsites.net/DashboardLogin" className="linkLogin">here </a> {CleanersDashboardTokenExpireConstant.DashboardLogoutP3} </p> : null}
          {this.state.logoutUrlDevUat ? <p className="linkPara">{CleanersDashboardTokenExpireConstant.DashboardLogoutP1} <a href="https://coop-cleaners-dashboard.azurewebsites.net/DashboardLogin" className="linkLogin">here </a> {CleanersDashboardTokenExpireConstant.DashboardLogoutP3} </p> : null}
          <p className="furthurSupport" >{CleanersDashboardTokenExpireConstant.DashboardLogoutP4}
            {/* <a href="mailto:visit@coop.co.uk" className="linkLogin">{CleanersDashboardTokenExpireConstant.DashboardLogoutP5}</a> */}
          </p>
        </div>
      </div>


    )
  }

}
export default CleanersDashboardTokenExpire;